"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countryCalendars = exports.LocationNotificationActions = exports.getRolesContainingThis = exports.LogisticsLocationRoles = void 0;
var LogisticsLocationRoles;
(function (LogisticsLocationRoles) {
    LogisticsLocationRoles["LogisticsManager"] = "Logistics Manager";
    LogisticsLocationRoles["LogisticsOperator"] = "Logistics Operator";
    LogisticsLocationRoles["LogisticsSupervisor"] = "Logistics Supervisor";
})(LogisticsLocationRoles = exports.LogisticsLocationRoles || (exports.LogisticsLocationRoles = {}));
function getRolesContainingThis(role) {
    switch (role) {
        case LogisticsLocationRoles.LogisticsManager:
            return [];
        case LogisticsLocationRoles.LogisticsSupervisor:
            return [LogisticsLocationRoles.LogisticsManager];
        case LogisticsLocationRoles.LogisticsOperator:
            return [
                LogisticsLocationRoles.LogisticsManager,
                LogisticsLocationRoles.LogisticsSupervisor,
            ];
        default:
            throw new Error(`Unable to find containing roles for ${role}`);
    }
}
exports.getRolesContainingThis = getRolesContainingThis;
var LocationNotificationActions;
(function (LocationNotificationActions) {
    LocationNotificationActions["CREATE"] = "location_create";
    LocationNotificationActions["UPDATE"] = "location_update";
})(LocationNotificationActions = exports.LocationNotificationActions || (exports.LocationNotificationActions = {}));
exports.countryCalendars = 'countryCalendars';
//# sourceMappingURL=location.js.map